import { ONBOARDING_ROUTES } from "@src/routes/routes";

export const OnboardingRoutes = [
  {
    path: ONBOARDING_ROUTES.GetStarted,
    lazy: async () => {
      const { GetStartedRoute } =
        await import("@src/features/getStarted/GetStarted.route");
      return { element: <GetStartedRoute /> };
    },
  },
];
